import React, { Component } from 'react';

class LazyErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasLazyError: false };
  }

  static getDerivedStateFromError(error) {
    // Se actualiza el estado si se detecta un error de carga
    if (
      error.message &&
      error.message.toLowerCase().includes('loading chunk')
    ) {
      return { hasLazyError: true };
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    // En lugar de usar console.error, considera enviar el error a un servicio de monitoreo
    // como Sentry, LogRocket, etc.
    // eslint-disable-next-line no-console
    console.error('LazyErrorBoundary caught an error:', error, errorInfo);
    // Por ahora, solo dejo el comentario como ejemplo.
  }

  render() {
    const { hasLazyError } = this.state; // Uso de destructuring para acceder al estado
    const { children } = this.props; // Uso de destructuring para acceder al estado

    if (hasLazyError) {
      return (
        <h2>
          Falló al cargar la página. Verifica tu conexión a internet y vuelve a
          intentar
        </h2>
      );
    }

    return children;
  }
}

export default LazyErrorBoundary;
